module.exports = __webpack_public_path__ + "static/media/the_hidden_plastic_in_our_food_system_tablet.6434fd37.jpg";